
    import './styles.scoped.css';
    export default {
  "header": "awsui_header_16mm3_9tx6k_99",
  "disabled": "awsui_disabled_16mm3_9tx6k_116",
  "expandable-header": "awsui_expandable-header_16mm3_9tx6k_120",
  "rolled-down": "awsui_rolled-down_16mm3_9tx6k_131",
  "highlighted": "awsui_highlighted_16mm3_9tx6k_134",
  "is-focused": "awsui_is-focused_16mm3_9tx6k_152",
  "variant-navigation": "awsui_variant-navigation_16mm3_9tx6k_156",
  "category": "awsui_category_16mm3_9tx6k_168",
  "expandable": "awsui_expandable_16mm3_9tx6k_120",
  "expand-icon": "awsui_expand-icon_16mm3_9tx6k_190",
  "expand-icon-up": "awsui_expand-icon-up_16mm3_9tx6k_197",
  "expand-icon-right": "awsui_expand-icon-right_16mm3_9tx6k_200",
  "items-list-container": "awsui_items-list-container_16mm3_9tx6k_214"
};
  